import type { ResultWrapper } from '../base';

export class PartiallyConstructible {
  /** @internal */
  _marker() { }
}

export type DeepPartial<T> = T extends PartiallyConstructible
  ? { [P in keyof T]?: DeepPartial<T[P]> }
  : T;

/** @internal */
export function mapRTUUIResult<T>(
  result: ResultWrapper<DeepPartial<T>>,
  LClass: new (source: DeepPartial<T>) => T
): ResultWrapper<T> {
  if (result.status === 'OK') {
    return {
      ...result,
      data: new LClass(result.data),
    };
  } else {
    return result;
  }
}

/** @internal */
export function mapRTUUIListResult<T>(
  result: ResultWrapper<DeepPartial<T>[]>,
  LClass: new (source: DeepPartial<T>) => T
): ResultWrapper<T[]> {
  if (result.status === 'OK') {
    return {
      ...result,
      data: result.data.map((i) => new LClass(i)),
    };
  } else {
    return result;
  }
}

/** @internal */
export function mapPlainResult<T>(jsObject: { result: T }): T {
  return jsObject.result;
}

export class Point {
  public x: number;
  public y: number;

  public constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}

export type Rectangle = {
  width: number;
  height: number;
  x: number;
  y: number;
};
